import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
//STORE CHAT
import profile from '@/store/modules/profile'
import channels from '@/store/modules/channels'
import messages from '@/store/modules/messages'
import contacts from '@/store/modules/contacts'


import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";

import { COMMIT_SET_STATUS } from '@/store/enums/mutations-types'


config.rawError = true;

const store = createStore({
  state(){
    return{
      status: null,
      profile: {
        lastname: 'Doe'
      }
    }
  }, 
  getters: {
    lastname: (state, getters, rootState: any) : any => {
     
      return rootState.profile.lastname
    }
  }, 
  mutations: {
    [COMMIT_SET_STATUS](state, payload){
      state.status = payload
    }
  },
  actions: {},

  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    profile,
    channels,
    messages,
    contacts
  },
});

export default store;
